








import { OComponentDemo } from '../../app/demo';
import ORadio from './o-radio.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'ORadioDemo',
  data() {
    return {
      data: {
        fruit: 'APPLE',
      },
    };
  },
  components: { ORadio, OComponentDemo },
});
